// extracted by mini-css-extract-plugin
export default {"stack":"Stack_stack__6th02"};